module.exports = __webpack_public_path__ + "img/start.803582e5.svg";